export const EMULATED_USER_ID = 'emulated-user-id';
export const USER_PROJECT_ID = 'user-project-id';
export const CLIENT_ID = 'client-id';
export const IS_ENCODED = 'is-encoded';
